import React from 'react';
import {Toggle, InputGroup, DateRangePicker, RadioTile, RadioTileGroup} from 'rsuite';
import moment from "moment/moment";
import StatusControl from "../../../../../shared/StatusControl/StatusControl";

const DimmerRelaySection = ({
                              relayEnabled,
                              relayMode,
                              relayIsActive,
                              onToggleRelay,
                              onChangeRelayMode,
                              loading,
                              timeScheduler,
                              duskDawnScheduler
                            }) => {

  const handleToggleRelay = async (enabled) => {
    await onToggleRelay(enabled);
  };

  const handleRelayModeChange = async (relayMode) => {
    await onChangeRelayMode(relayMode)
  };

  const getDuskDawnSchedulerTime = () => {
    if (!duskDawnScheduler || duskDawnScheduler.length < 2) return '';
    return `${moment(duskDawnScheduler[0]).format('HH:mm')} - ${moment(duskDawnScheduler[1]).format('HH:mm')}`
  };

  const getTimeSchedulerText = () => {
    if (!timeScheduler || timeScheduler.length < 2) return '';
    return `${moment(timeScheduler[0]).format('HH:mm')} - ${moment(timeScheduler[1]).format('HH:mm')}`;
  };



  return (
    <>
      <section>
        <div className="row p-1 text-center">
          <div className="col-md-12">
            <div className="d-flex text-start">
              <StatusControl
                style={{marginLeft: '-5px'}}
                status={relayIsActive ? "online" : "offline"}/>
              <Toggle
                style={{marginLeft: '10px', marginTop: '5px'}}
                size="sm"
                checked={relayEnabled}
                loading={loading}
                onChange={handleToggleRelay}
                color="blue"
                checkedChildren="ON"
                unCheckedChildren="OFF">
                Включено / Выключено
              </Toggle>
            </div>
            <div className="row mt-3">
              <RadioTileGroup
                aria-label="Режим работы реле"
                name="relay-group"
                value={String(relayMode)}
                onChange={(value) => handleRelayModeChange(Number(value))}
                disabled={loading}
              >
                <div className="col-12 text-start">
                  <RadioTile value="0" label="Реле в ручном управлении">
                    <span className="radio-tile-text">Управление реле осуществляется вручную.</span>
                  </RadioTile>
                </div>
                <div className="col-12 text-start">
                  <RadioTile value="1" label={`Реле используется с таймером: ${getTimeSchedulerText()}`}>
                  <span className="radio-tile-text">Реле переключается по заданному расписанию.</span>
                  </RadioTile>
                </div>

                <div className="col-12 text-start">
                  <RadioTile value="2" label={`Реле используется с восходом / закатом: ${getDuskDawnSchedulerTime()}`}>
                  <span className="radio-tile-text">Реле управляется по времени восхода и заката.</span>
                  </RadioTile>
                </div>
              </RadioTileGroup>
            </div>

          </div>
          <div className="col-md-12 mt-3">
            <InputGroup style={{marginBottom: '5px'}}>
              <InputGroup.Addon>По времени</InputGroup.Addon>
              <DateRangePicker
                value={timeScheduler}
                style={{width: '100%'}}
                format="HH:mm"
                readOnly={true}/>
            </InputGroup>
          </div>
          {/*<div className="col-md-12">*/}
          {/*  <InputGroup style={{marginBottom: '5px'}}>*/}
          {/*    <InputGroup.Addon>Восход - Закат</InputGroup.Addon>*/}
          {/*    <Input*/}
          {/*      value={getDuskDawnSchedulerTime()}*/}
          {/*      style={{width: '100%'}}*/}
          {/*    />*/}
          {/*  </InputGroup>*/}
          {/*</div>*/}
        </div>
      </section>
    </>
  );
};

export default DimmerRelaySection;
